<template>
  <div>
    <div @mousemove="move" class="w3l-banner">
      <div
        :style="
          'transform: translate(' +
          (position == 'left' ? '20' : '-20') +
          'px,' +
          (position2 == 'top' ? '10' : '-10') +
          'px) scale(1.1)'
        "
        class="banner-image"
      ></div>
      <div class="titleBox" :class="contType == 'e' ? 'titleBoxe' : ''">
        <div class="wow flipInX titleT1" :class="contType == 'e' ? 'titleT1e' : ''">{{ contList.title1[contType] }}</div>
        <div class="wow flipInX titleT2" :class="contType == 'e' ? 'titleT2e' : ''">{{ contList.title3[contType] }}</div>
        <img class="wow bounceInDown titlebgIcon1" src="../assets/img/safety/icon.svg" alt="" />
        <img
          class="wow bounceInDown titlebgIcon2"
          src="../assets/img/safety/safety.svg"
          alt=""
        />
        <img class="wow bounceInUp titlebg" src="../assets/img/safety/person.svg" alt="" />
      </div>
    </div>

    <div class="contBox">
      <div class="programme2">
        <div class="wow bounceInUp programme2L">
          <img class="programmeBG" src="../assets/img/safety/1250.png" alt="" />
        </div>
        <div class="wow bounceInUp programme2R">
          <div class="programme2RT1">
            {{ contList.programme2T[contType][0] }}
          </div>
          <div class="programme2RT2">
            {{ contList.programme2T[contType][1] }}
          </div>
          <div class="programme2RT2">
            {{ contList.programme2T[contType][2] }}
          </div>
          <div class="programme2RT2">
            {{ contList.programme2T[contType][3] }}
          </div>
          <div class="programme2RT2">
            {{ contList.programme2T[contType][4] }}
          </div>
        </div>
      </div>
    </div>
    <div class="contBox1">
      <div class="contBox">
        <div class="programme1">
          <div class="wow bounceInUp programme1R">
            <div class="programme2RT1">
              {{ contList.programme1T[contType][0] }}
            </div>
            <div class="programme2RT2">
              {{ contList.programme1T[contType][1] }}
            </div>
            <div class="programme2RT2">
              {{ contList.programme1T[contType][2] }}
            </div>
            <div class="programme2RT2">
              {{ contList.programme1T[contType][3] }}
            </div>
          </div>
          <div class="wow bounceInUp programme1L">
            <img
              class="programmeBG top386"
              src="../assets/img/safety/1248.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="contBox">
      <div class="programme2">
        <div class="wow bounceInUp programme2L">
          <img class="programmeBG" src="../assets/img/safety/1247.png" alt="" />
        </div>
        <div class="wow bounceInUp programme2R">
          <div class="programme2RT1">
            {{ contList.programme3T[contType][0] }}
          </div>
          <div class="programme2RT2 textIndent2em programme2RT11">
            {{ contList.programme3T[contType][1] }}
          </div>
          <div class="programme2RT2" style="font-weight: 600;">
            {{ contList.programme3T[contType][2] }}
          </div>
          <div class="programme2RT2" style="padding-top: 0px">
            {{ contList.programme3T[contType][3] }}
          </div>
          <div class="programme2RT2" style="font-weight: 600;">
            {{ contList.programme3T[contType][4] }}
          </div>
          <div class="programme2RT2" style="padding-top: 0px">
            {{ contList.programme3T[contType][5] }}
          </div>
          <div class="programme2RT2" style="font-weight: 600;">
            {{ contList.programme3T[contType][6] }}
          </div>
          <div class="programme2RT2" style="padding-top: 0px">
            {{ contList.programme3T[contType][7] }}
          </div>
        </div>
      </div>
    </div>
    <div class="contBox3">
      <div class="contBox dc">
        <div class="wow bounceInUp contBox3T">
          {{ contList.programme4T[contType][0] }}
        </div>
        <div class="wow bounceInUp programme4">
          <div>
            <img
              class="programmeBG4"
              src="../assets/img/safety/pci.svg"
              alt=""
            />
          </div>
          <div class="programme4R">
            {{ contList.programme4T[contType][1] }}
          </div>
        </div>
        <div class="imgBox">
          <img
            class="wow bounceInUp certificatImg"
            src="../assets/img/safety/certificat1.png"
            alt=""
          />
          <img
            class="wow bounceInUp certificatImg"
            data-wow-delay="0.1s"
            src="../assets/img/safety/certificat2.svg"
            alt=""
          />
          <img
            class="wow bounceInUp certificatImg"
            data-wow-delay="0.2s"
            src="../assets/img/safety/certificat3.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="contBox textBox">
      <div class="wow bounceInUp contBox3T">
        {{ contList.programme5T[contType][0] }}
      </div>
      <div class="wow bounceInUp contBox4T">
        {{ contList.programme5T[contType][1] }}
      </div>
      <div class="wow bounceInUp contBox4LT" v-html="contList.programme5T[contType][2]">
      </div>
      <div class="wow bounceInUp contBox4BGT" :class="contType == 'e' ? 'contBox4BGTe' : ''">
        <div>{{contList.programme5T[contType][3]}}</div>
      </div>
      <div class="wow bounceInUp contBox4LT width-32" style="text-indent:2em;width:1116px;">
        <p style="margin-top: 16px;">{{contList.programme5T[contType][4]}}</p>
        <p style="margin-top: 8px;">{{contList.programme5T[contType][5]}}</p>
        <p style="margin-top: 8px;">{{contList.programme5T[contType][6]}}</p>
      </div>
      <div class="wow bounceInUp contBox4BGT" :class="contType == 'e' ? 'contBox4BGTe' : ''">
        <div>{{contList.programme5T[contType][7]}}</div>
      </div>
      <div class="wow bounceInUp contBox4LT width-32" style="text-indent:2em;width:1116px;">
        <p style="margin-top: 16px;">{{contList.programme5T[contType][8]}}</p>
      </div>
      <div class="wow bounceInUp contBox4ST">
        {{ contList.programme5T[contType][9] }}
      </div>
      <div class="wow bounceInUp contBox4LT MGTL " v-html="contList.programme5T[contType][10]">
      </div>
      <div class="wow bounceInUp contBox4ST">
        {{ contList.programme5T[contType][11] }}
      </div>
      <div class="wow bounceInUp contBox4LT MGTL" v-html="contList.programme5T[contType][12]">
      </div>
      <div class="wow bounceInUp contBox4ST">
        {{ contList.programme5T[contType][13] }}
      </div>
      <div class="wow bounceInUp contBox4LT width-32" style="text-indent:2em;width:1116px;">
        <p style="margin-top: 8px;">{{contList.programme5T[contType][14]}}</p>
      </div>
      <div class="wow bounceInUp contBox4ST">
        {{ contList.programme5T[contType][15] }}
      </div>
      <div class="wow bounceInUp contBox4LT MGTL width-32" style="width:1088px;" v-html="contList.programme5T[contType][16]">
      </div>
      <div class="wow bounceInUp contBox4ST">
        {{ contList.programme5T[contType][17] }}
      </div>
      <div class="wow bounceInUp contBox4LT width-32" style="text-indent:2em;width:1116px;">
        <p style="margin-top: 8px;">{{contList.programme5T[contType][18]}}</p>
      </div>
      <div class="wow bounceInUp contBox4BGT" :class="contType == 'e' ? 'contBox4BGTe' : ''">
        <div>{{contList.programme5T[contType][19]}}</div>
      </div>
      <div class="wow bounceInUp contBox4LT width-32" style="text-indent:2em;width:1116px;">
        <p style="margin-top: 16px;">{{contList.programme5T[contType][20]}}</p>
        <p style="margin-top: 8px;">{{contList.programme5T[contType][21]}}</p>
        <p style="margin-top: 8px;">{{contList.programme5T[contType][22]}}</p>
      </div>
      <div class="wow bounceInUp contBox4BGT" :class="contType == 'e' ? 'contBox4BGTe' : ''">
        <div>{{contList.programme5T[contType][23]}}</div>
      </div>
      <div class="wow bounceInUp contBox4ST">
        {{ contList.programme5T[contType][24] }}
      </div>
      <div class="wow bounceInUp contBox4LT MGTL" v-html="contList.programme5T[contType][25]">
      </div>
      <div class="wow bounceInUp contBox4ST">
        {{ contList.programme5T[contType][26] }}
      </div>
      <div class="wow bounceInUp contBox4LT MGTL" v-html="contList.programme5T[contType][27]">
      </div>
      <div class="wow bounceInUp contBox4ST">
        {{ contList.programme5T[contType][28] }}
      </div>
      <div class="wow bounceInUp contBox4LT MGTL width-32" style="width:1088px;" v-html="contList.programme5T[contType][29]">
      </div>
      <div class="wow bounceInUp contBox4ST">
        {{ contList.programme5T[contType][30] }}
      </div>
      <div class="wow bounceInUp contBox4LT MGTL width-32" style="width:1088px;" v-html="contList.programme5T[contType][31]">
      </div>
      <div class="wow bounceInUp contBox4BGT" :class="contType == 'e' ? 'contBox4BGTe' : ''">
        <div>{{contList.programme5T[contType][32]}}</div>
      </div>
      <div class="wow bounceInUp contBox4LT width-32" style="text-indent:2em;width:1116px;">
        <p style="margin-top: 16px;">{{contList.programme5T[contType][33]}}</p>
        <p style="margin-top: 8px;">{{contList.programme5T[contType][34]}}</p>
      </div>
      <div class="wow bounceInUp contBox4BGT" :class="contType == 'e' ? 'contBox4BGTe' : ''">
        <div>{{contList.programme5T[contType][35]}}</div>
      </div>
      <div class="wow bounceInUp contBox4LT width-32" style="text-indent:2em;width:1116px;">
        <p style="margin-top: 16px;">{{contList.programme5T[contType][36]}}</p>
      </div>
      <div class="wow bounceInUp contBox4BGT" :class="contType == 'e' ? 'contBox4BGTe' : ''">
        <div>{{contList.programme5T[contType][37]}}</div>
      </div>
      <div class="wow bounceInUp contBox4LT width-32 mgb50" style="text-indent:2em;width:1116px;">
        <p style="margin-top: 16px;">{{contList.programme5T[contType][38]}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";

export default {
  name: "index",
  data: (vm) => {
    return {
      bodyW: 0,
      bodyY: 0,
      position: "",
      position2: "",
      contList: {
        title1: {
          z: "安全保障",
          f: "安全保障",
          e: 'Safety guarantee'
        },
        title3: {
          z: "合规是我们的立身之本，更是您的安全保障！",
          f: "合規是我們的立身之本，更是您的安全保障！",
          e: "Compliance is not only our foundation, but also your security!",
        },
        programme2T: {
          z: [
            "监管合规",
            "• 严格遵循国际反洗钱公约以及监管机构的相关法律法规。",
            "• 聘请国际会计师事务所对财务和运营情况进行审计，确保自身的合规性。",
            "• 按照国际支付行业的最高标准建立合规体系，对客户进行严格身份认证和尽职调查。",
            "• 通过百余场景及千余规则的交易监控措施，全面识别反欺诈及其他金融犯罪。",
          ],
          f: [
            "監管合規",
            "• 嚴格遵循國際反洗錢公約以及監管機構的相關法律法規。",
            "• 聘請國際會計師事務所對財務和運營情況進行審計，確保自身的合規性。",
            "• 按照國際支付行業的最高標準建立合規體繫，對客戶進行嚴格身份認証和儘職調查。",
            "• 通過百餘場景及千餘規則的交易監控措施，全麵識別反欺詐及其他金融犯罪。",
          ],
          e: [
            "Regulatory Compliance",
            "• We'll strictly comply with international AML conventions and relevant laws and regulations of regulatory bodies.",
            "• We'll engage an international CPA firm to audit our financial and operational conditions and ensure internal compliance.",
            "• We'll establish a compliance system in accordance with the highest standards of the international payment industry, and carry out strict identity authentication and due diligence on our customers.",
            "• Through transaction monitoring measures for more than a hundred scenarios and more than a thousand rules, we'll comprehensively identify and prevent against fraud and other financial crimes.",
          ],
        },
        programme1T: {
          z: [
            "资金安全",
            "• 我们的业务方案经过合作商业银行从海外到中国的多重合规检验。客户境外资金存放于国际一级清算银行的备付金账户，受各国金融监管部门和银行的双重保护；",
            "• 境内资金 100%由持有第三方支付牌照及跨境支付牌照的支付机构处理，所有资金操作严格按照客户的指令进行，任何篡改及账户异常情况将不被索图及合作金融机构接受；",
            "• 根据授权和监管规定，索图保有充足的资金以保证自身业务，同时也进一步保护客户的利益。",
          ],
          f: [
            "資金安全",
            "• 我們的業務方案經過合作商業銀行從海外到中國的多重合規檢驗。客戶境外資金存放於國際一級清算銀行的備付金賬戶，受各國金融監管部門和銀行的雙重保護；",
            "• 境內資金 100%由持有第三方支付牌照及跨境支付牌照的支付機構處理，所有資金操作嚴格按照客戶的指令進行，任何篡改及賬戶異常情況將不被索圖及合作金融機構接受；",
            "• 根據授權和監管規定，索圖保有充足的資金以保証自身業務，同時也進一步保護客戶的利益。",
          ],
         e: [
            "Capital Security",
            "• Our business solutions have passed multiple compliance verifications by cooperative commercial banks from overseas to China.The reserve accounts of customers' overseas funds deposited in first-class international clearing banks shall be protected by the financial regulatory and supervisory authorities and banks in various countries.",
            "• 100% of domestic funds shall be handled by payment agencies holding third-party payment licenses and cross-border payment licenses. All funds shall be handled in strict accordance with the instructions of the customers. Any tamper and account abnormality will not be accepted by Suntone and cooperative financial institutions.",
            "• In accordance with authorization and regulatory provisions, Suntone maintains sufficient capitals to ensure its normal business and further protect the interests of its customers.",
          ],
        },
        programme3T: {
          z: [
            "隐私保护",
            "强大的加密措施保护客户信息，同时以严格的制度、流程管控信息流转。",
            "• 用户授权",
            '对信息采集处理的所有行为均经信息主体同意。',
            "• 加密存储",
            '客户信息的均被进行加密及再存储。',
            "• 信息脱敏",
            '客户敏感信息均被进行脱敏存储和显示。'
          ],
          f: [
            "隱私保護",
            "強大的加密措施保護客戶信息，同時以嚴格的製度、流程管控信息流轉。",
            "• 用戶授權",
            '對信息採集處理的所有行爲均經信息主體同意。',
            "• 加密存儲",
            '客戶信息的均被進行加密及再存儲。',
            "• 信息脫敏",
            '客戶敏感信息均被進行脫敏存儲和顯示。'
          ],
          e: [
            "Privacy Protection",
            "We have powerful encryption measures to protect customer information, while strict rules and procedures are in place to control information flow.",
            '• User authorization',
            "All acts of information collection and processing authorized by the user are agreed by the data subject.",
            '• Encrypted storage',
            "All customer information for encrypted storage is encrypted and re-stored.",
            '• Information desensitization',
            "All sensitive information of information desensitized customers is stored and displayed after desensitization.",
          ],
        },
        programme4T: {
          z: [
            "安全认证",
            "Suntone自持美国MSB和香港MSO牌照，作为少数有能力开展多区域金融科技服务的中资企业之一，完善的合规风控体系接受全球相关行业监管机构的合规检验，获得全球权威安全评估资质PCI认证，得到海内外合作银行的认可和支持，为跨境电商提供安全、专业和快捷的独立站跨境收单服务和跨境平台收款服务。",
          ],
          f: [
            "安認全證",
            "Suntone自持美國MSB和香港MSO牌照，作爲少數有能力開展多區域金融科技服務的中資企業之一，完善的合規風控體繫接受全球相關行業監管機構的合規檢驗，獲得全球權威安全評估資質PCI認証，得到海內外合作銀行的認可和支持，爲跨境電商提供安全、專業和快捷的獨立站跨境收單服務和跨境平颱收款服務。",
          ],
          e: [
            "Security Certification",
            "Suntone holds the MSB license in the United States and the MSO license in Hong Kong. As one of the few Chinese enterprises with the ability to carry out multi-regional fintech services, Suntone has a perfect compliance risk control system (Security), which is subject to the compliance verification by relevant industry regulators around the world, has obtained the PCI certification of the global authoritative security assessment qualification, and has been recognized and supported by domestic and foreign cooperative banks. Suntone delivers safe, professional and fast standalone station cross-border acquiring services and cross-border platform collection services for cross-border e-commerce merchants across the Standards Council.",
          ],
        },
        programme5T: {
          z: [
            "隐私政策",
            "本政策适用于索图科技技术有限公司（以下称“索图”）可能收集到的关于以下人员的信息：",
            "<br>• 索图网站的访客；<br>• 在网站注册账户并使用我们提供的服务的公司和个人；<br>• 通过电话或书面与我们联系的任何个人信息。<br>• 在保护客户利益方面，索图一直致力于为客户提供更安全、更可靠的服务。<br>• 在您注册帐户并向我们提供您的个人信息前，请阅读本隐私政策。我们尤其重视客户隐私并通过健全的实践以确保：<br>• 仅收集监管机构要求和改进服务所需的信息；<br>• 正当收集并安全存储个人信息。<br>• 如果您对索图的数据保护存在任何其他疑问，请立即联系我们，我们将尽力为您释疑。",
            "我们如何收集您的信息？",
            "当您访问我们的网站、注册索图帐户（不管是在线注册还是填写纸质表单注册）或与我们进行电话或书面联系时，索图将收集您的相关信息。",
            "一旦您注册索图帐户，我们将收集、处理和存储您的信息，包括但不限于您的姓名、邮政地址、电子邮件地址、电话号码及出生日期。一旦您设置好您的帐户并通过我们进行交易，我们将收集、处理和存储您的财务和交易信息。",
            "我们还使用Cookie，以改善您的用户体验。",
            "我们用您的信息来干什么？",
            "我们使用您的个人信息处理您的注册，以及您通过我们进行的交易，并保证您账户信息的准确性。",
            "注册和管理",
            "• 我们使用您的信息完成您的注册<br>• 在您拥有我们的帐户后，我们通过您的联系方式与您取得联系，回复您的任何询问或请求。<br>• 管理您的账户时，我们可能会用到您的信息，其中包括联系您更新账户信息（这将有助于使我们的记录尽可能地保持最新）、通知您我们的产品或服务的变更及改进情况。",
            "我们的产品和服务",
            "• 我们使用您的信息是为了向您提供我们的产品和服务，以履行我们对您的合同义务。<br>• 此外，我们可能需要通知您有关我们的产品和服务所做的变更。",
            "预防和侦查犯罪",
            "索图严格遵守反洗钱法规，因此我们需要对客户进行尽职调查。这可能包括使用电子验证工具。如果无法进行电子验证，我们会要求客户提供身份证件和地址证明文件的复印件。我们可能需要将您的信息提交给政府机构、监管机构、警察/执法部门或法院。这么做将有助于防止犯罪（洗钱/诈骗）、满足法律要求或其他合法目的。",
            "营销",
            "• 我们可能会使用您的信息帮助您随时了解我们产品和服务的最新情况。<br>• 客户调查有助于我们改进服务。我们可能会发送电子邮件邀请您参与调查或要求您对我们的服务做出反馈。这些信息仅可以汇总的形式与附属第三方共享。<br>• 我们可能使用您访问我们的网站或注册我们的服务时提供的信息，通过社交媒体平台向您推广我们的服务。为此，我们可能会将这些信息提交给第三方，如Facebook。如果您不希望收到此类广告，请与我们联系。",
            "监控",
            "出于安全和培训目的，我们会对我们所有的电话进行录音。",
            "信息安全/存储",
            "我们采取了物理、电子和程序措施保护您的信息。我们对所有数据都进行了电子存储。数据存储在位于英国的服务器上，并受积极维护的防火墙保护。我们使用最新的杀毒软件且数据存储服务器的物理访问受限。",
            "如果您向我们提供了纸质文档，我们会保留您的纸质文档，并保存电子版副本。",
            "互联网上传输数据不可能做到绝对安全。我们不会也不能保证通过电子方式收集和传输的信息的安全性，但我们会合理谨慎地保护您的个人信息。",
            "数据共享",
            "索图公司",
            "我们可能会与索图公司下属的其他公司共享您的信息，为您提供服务。虽然我们的一些公司可能位于不同的司法管辖区，但我们将确保整个公司在数据保护要求方面的一致性。",
            "监管机构",
            "我们可能需要与监管机构或执法机构共享您的信息。",
            "银行",
            "• 我们可能与第三方共享您的信息以处理您的交易，如我们的银行交易对手。<br>• 鉴于我们的业务性质，我们可能需要与您居住国之外的人员或组织共享您的信息，如中转或收款银行。比方说，当您请求我们向中国支付美元时，这笔钱在到达中国前，将先通过海外的中转银行进行清算，这将要求我们提供一些付款信息，其中可能包括您的姓名和地址。",
            "其他方",
            "• 我们可能会与您授权的人、代表您的人或把您介绍给我们的索图联名品牌或品牌合作伙伴共享您的信息。<br>• 我们不会出售关于您的任何个人数据。",
            "如何索要信息？",
            "您有权向我们索要关于您的详细信息，如信息描述，信息的使用目的，我们与何方在共享你的信息。",
            "当我们向你提供这些信息时，我们可能会向您收取一定的管理费。",
            "个人信息保留多久？",
            "索图仅在必要时会保留您的信息，但通常不会超过有关业务关系终止后6年。",
            "本政策如何更新？",
            "我们保留更新或修改本政策的权利。若我们对此政策做出重大改变，我们将通过您提供给我们的电子邮件地址通知您，或在我们的网站上放置醒目的通知。",
          ],
          f: [
            "隱私政策",
            "本政策適用於索圖科技技術有限公司（以下稱“索圖”）可能收集到的關於以下人員的信息：",
            "<br>• 索圖網站的訪客；<br>• 在網站注冊賬戶並使用我們提供的服務的公司和個人；<br>• 通過電話或書麵與我們聯繫的任何個人信息。<br>• 在保護客戶利益方麵，索圖一直緻力於爲客戶提供更安全、更可靠的服務。<br>• 在您注冊帳戶並向我們提供您的個人信息前，請閱讀本隱私政策。我們尤其重視客戶隱私並通過健全的實踐以確保：<br>• 僅收集監管機構要求和改進服務所需的信息；<br>• 正當收集並安全存儲個人信息。<br>• 如果您對索圖的數據保護存在任何其他疑問，請立即聯繫我們，我們將儘力爲您釋疑。",
            "我們如何收集您的信息？",
            "當您訪問我們的網站、注冊索圖帳戶（不管是在線注冊還是填冩紙質表單注冊）或與我們進行電話或書麵聯繫時，索圖將收集您的相關信息。",
            "一旦您注冊索圖帳戶，我們將收集、處理和存儲您的信息，包括但不限於您的姓名、郵政地址、電子郵件地址、電話號碼及出生日期。一旦您設置好您的帳戶並通過我們進行交易，我們將收集、處理和存儲您的財務和交易信息。",
            "我們還使用Cookie，以改善您的用戶體驗。",
            "我們用您的信息來幹什麼？",
            "我們使用您的個人信息處理您的注冊，以及您通過我們進行的交易，並保証您賬戶信息的準確性。",
            "注冊和管理",
            "• 我們使用您的信息完成您的注冊<br>• 在您擁有我們的帳戶後，我們通過您的聯繫方式與您取得聯繫，回複您的任何詢問或請求。<br>• 管理您的賬戶時，我們可能會用到您的信息，其中包括聯繫您更新賬戶信息（這將有助於使我們的記錄儘可能地保持最新）、通知您我們的産品或服務的變更及改進情況。",
            "我們的産品和服務",
            "• 我們使用您的信息是爲了向您提供我們的産品和服務，以履行我們對您的合同義務。<br>• 此外，我們可能需要通知您有關我們的産品和服務所做的變更。",
            "預防和偵查犯罪",
            "索圖嚴格遵守反洗錢法規，因此我們需要對客戶進行儘職調查。這可能包括使用電子驗証工具。如果無法進行電子驗証，我們會要求客戶提供身份証件和地址証明文件的複印件。我們可能需要將您的信息提交給政府機構、監管機構、警察/執法部門或法院。這麼做將有助於防止犯罪（洗錢/詐騙）、滿足法律要求或其他合法目的。",
            "營銷",
            "• 我們可能會使用您的信息幫助您隨時了解我們産品和服務的最新情況。<br>• 客戶調查有助於我們改進服務。我們可能會髮送電子郵件邀請您參與調查或要求您對我們的服務做出反饋。這些信息僅可以匯總的形式與附屬第三方共享。<br>• 我們可能使用您訪問我們的網站或注冊我們的服務時提供的信息，通過社交媒體平颱向您推廣我們的服務。爲此，我們可能會將這些信息提交給第三方，如Facebook。如果您不希望收到此類廣告，請與我們聯繫。",
            "監控",
            "出於安全和培訓目的，我們會對我們所有的電話進行錄音。",
            "信息安全/存儲",
            "我們採取了物理、電子和程序措施保護您的信息。我們對所有數據都進行了電子存儲。數據存儲在位於英國的服務器上，並受積極維護的防火牆保護。我們使用最新的殺毒軟件且數據存儲服務器的物理訪問受限。",
            "如果您向我們提供了紙質文檔，我們會保留您的紙質文檔，並保存電子版副本。",
            "互聯網上傳輸數據不可能做到絶對安全。我們不會也不能保証通過電子方式收集和傳輸的信息的安全性，但我們會合理謹慎地保護您的個人信息。",
            "數據共享",
            "索圖公司",
            "我們可能會與索圖公司下屬的其他公司共享您的信息，爲您提供服務。雖然我們的一些公司可能位於不同的司法管轄區，但我們將確保整個公司在數據保護要求方麵的一緻性。",
            "監管機構",
            "我們可能需要與監管機構或執法機構共享您的信息。",
            "銀行",
            "• 我們可能與第三方共享您的信息以處理您的交易，如我們的銀行交易對手。<br>• 鑑於我們的業務性質，我們可能需要與您居住國之外的人員或組織共享您的信息，如中轉或收款銀行。比方說，當您請求我們向中國支付美元時，這筆錢在到達中國前，將先通過海外的中轉銀行進行清算，這將要求我們提供一些付款信息，其中可能包括您的姓名和地址。",
            "其他方",
            "• 我們可能會與您授權的人、代表您的人或把您介紹給我們的索圖聯名品牌或品牌合作夥伴共享您的信息。<br>• 我們不會出售關於您的任何個人數據。",
            "如何索要信息？",
            "您有權向我們索要關於您的詳細信息，如信息描述，信息的使用目的，我們與何方在共享你的信息。",
            "當我們向你提供這些信息時，我們可能會向您收取一定的管理費。",
            "個人信息保留多久？",
            "索圖僅在必要時會保留您的信息，但通常不會超過有關業務關繫終止後6年。",
            "本政策如何更新？",
            "我們保留更新或修改本政策的權利。若我們對此政策做出重大改變，我們將通過您提供給我們的電子郵件地址通知您，或在我們的網站上放置醒目的通知。",
            ],
          e: [
            "Privacy Policy",
            "This policy applies to the information that Suntone Technology Co., Ltd. (hereinafter referred to as “Suntone”) may collect about the following persons:",
            "<br>• Visitors to Suntone's website;<br>• Companies and individuals who have registered an account on the website and use the services we provide;<br>• Information about any individuals who contact us by telephone or in writing;<br>• As for protecting the interests of customers, Suntone has been committed to providing customers with safer and more reliable services;<br>• Please read this Privacy Policy before you register an account and provide us with your personal information; We take customer privacy particularly seriously and have robust practices to ensure;<br>• Collecting only information required by regulators and necessary to improve our services;<br>• Properly collecting and securely storing personal information;<br>• If you have any further questions about Suntone's data protection, please contact us immediately and we will do our best to resolve your doubt.",
            "How do we collect your information?",
            "Suntone will collect information about you when you visit our website, register for an account with Suntone (whether online or by filling out a printed form), or contact us by phone or in writing.",
            "Once you register for a Suntone account, we will collect, process and store your information, including but not limited to your name, postal address, email address, telephone number and date of birth. Once you have set up your account and have transaction through us, we will collect, process and store your financial and transactional information.",
            "We also use Cookie to improve your user experience.",
            "What do we do with your information?",
            "We use your personal information to process your registration, as well as your transactions through us, and ensure the accuracy of your account information.",
            "Registration and Administration",
            "• We use your information to complete your registration.<br>• After you have an account with us, we will contact you through your contact information to respond to any query or request you may have.<br>• We may use your information for the administration of your account, including to contact you to update your account information (which will help keep our records as current as possible) and to notify you of changes and improvements to our products or services.",
            "Our Products and Services",
            "• We use your information in order to provide you with our products and services to fulfill our contractual obligations to you.<br>• In addition, we may need to notify you about changes to our products and services.",
            "Prevention and Investigation of Crimes",
            "Suntone strictly adheres to AML regulations, so we need to conduct due diligence on our customers. This may include the use of electronic verification tools. If electronic verification is not possible, we will ask the customer to provide copies of identification and proof of address documents. We may need to submit your information to government agencies, regulatory bodies, police/law enforcement authorities or courts. Doing so will help prevent crime (money laundering/fraud), and meet legal requirements or other legitimate purposes.",
            "Marketing",
            "• We may use your information to keep you updated on our products and services.<br>• Customer surveys help us improve our services. We may send you emails inviting you to participate in surveys or asking for feedback on our services. This information may be shared with affiliated third parties only in summary form.<br>• We may use the information you provide when you visit our website or register for our services to promote our services to you through social media platforms. For this purpose, we may submit this information to third parties, such as Facebook. If you do not wish to receive such advertisements, please contact us.",
            "Monitoring",
            "For security and training purposes, we will record all our calls.",
            "Information Security/Storage",
            "We take physical, electronic and procedural measures to protect your information. All data are stored electronically on servers located in the United Kingdom and protected by actively maintained firewalls. We use up-to-date anti-virus software and have restricted physical access to data storage servers.",
            "If you provide us with printed documents, we will retain your printed documents and keep electronic copies.",
            "No data transmission over the Internet can be perfectly secure. We do not and cannot guarantee the security of information collected and transmitted electronically, but we will protect your personal information with due care.",
            "Data Sharing",
            "Suntone's Affiliated Companies",
            "We may share your information with other companies affiliated with Suntone to provide services to you. While some of our affiliated companies may be located in different jurisdictions, we will ensure consistency in data protection requirements in the whole company.",
            "Regulatory Agencies",
            "We may need to share your information with regulatory or law enforcement agencies.",
            "Banks",
            "• We may share your information with third parties to process your transactions, such as our banking counterparties.<br>• Given the nature of our business, we may need to share your information with persons or organizations outside your country of residence, such as transfer or collection banks. For example, when you ask us to pay U.S. dollars to China, the money will be cleared through an overseas transfer bank before it reaches China, and this will require us to provide some payment information, which may include your name and address.",
            "Other Parties",
            "• We may share your information with persons authorized by you, acting on your behalf, or Suntone's co-branded brands or brand partners who refer you to us.",
            "How to request information from us?",
            "You have the right to request from us detailed information about you, such as a description of the information, the purpose for which the information is being used, and with whom we are sharing your information.",
            "When we provide you with this information, we may charge you a certain management fee.",
            "How long will your personal information be retained?",
            "Suntone will retain your information only as long as necessary, but usually not for more than 6 years after the termination of related business relationship.",
            "How is this policy updated?",
            "We reserve the right to update or modify this policy. If we make material changes to this policy, we will notify you through the email address you provided to us or place a prominent notice on our website.",
            ],
        },
      },
      contType: "z",
    };
  },
  methods: {
    move(e) {
      if(e.pageX>(this.bodyW/2)){
        this.position = 'right'
      }else {
        this.position = 'left'
      }
      if(e.pageY>250){
        this.position2 = 'top'
      }else {
        this.position2 = 'bottom'
      }
    },
    changeTypeTitleName() {
        if (this.contType == "f") {
          document.title = "安全保障";
        }else if(this.contType == 'e'){
          document.title = 'Safety guarantee'
        } else {
          document.title = "安全保障";
        }
    }
  },

  mounted() {
    this.bodyW = document.body.clientWidth;
    this.bodyY = document.body.clientHeight;
    var that = this;
    this.contType = window.localStorage.getItem('language');
    that.changeTypeTitleName()
    window.addEventListener('setItemEvent', function(e) {
      if (e.key == "language") {
        that.contType = e.newValue;
        that.changeTypeTitleName()
      }
    })
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 40,
      mobile: true,
      live: true,
    });
    wow.init();
  },
};
</script>

<style src="../assets/css/Safety-pc.css"  scoped>

</style>
<style src="../assets/css/Safety-phone.css"  scoped>

</style>
